// baby: Shared 8-bit marketing kit used by /nin and /ninxl landings
export {
  Ninxl8BitThemeProvider,
  useNinxl8BitTheme,
  useNinxl8BitThemeMode,
  type Ninxl8BitTheme,
} from './use-8bit-theme'
export { Ninxl8BitThemeToggle } from './8bit-theme-toggle'
export { Ninxl8BitAtmosphere } from './8bit-atmosphere'
export {
  Ninxl8BitHud,
  Ninxl8BitFrame,
  Ninxl8BitSection,
  Ninxl8BitDivider,
} from './8bit-ui'
